import { Box } from '@nimbus-ds/components';
import LinkToMetafields, {
  LinkToMetafieldsProps,
} from '../LinkToMetafields/LinkToMetafields';

interface LinkToMetafieldsBasedOnUserProps extends LinkToMetafieldsProps {
  isFullUser: boolean;
  hasProductPermission?: boolean;
}

function LinkToMetafieldsBasedOnUser({
  isFullUser,
  hasProductPermission,
  ...props
}: Readonly<LinkToMetafieldsBasedOnUserProps>) {
  if (isFullUser || hasProductPermission)
    return <LinkToMetafields {...props} />;
  return <Box marginTop="4" />;
}

export default LinkToMetafieldsBasedOnUser;
